import { gql } from "graphql-tag";

export const GET_COUNTRY_WITH_SITE = gql`
    query GetCountryWithSites {
        country_with_site
    }
`;